var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"del-btn",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }